import { render, staticRenderFns } from "./AssessmentReporting.vue?vue&type=template&id=18a0d863&scoped=true&"
import script from "./AssessmentReporting.vue?vue&type=script&lang=js&"
export * from "./AssessmentReporting.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentReporting.vue?vue&type=style&index=0&id=18a0d863&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a0d863",
  null
  
)

export default component.exports